// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GSCFirstExample-module--wrapper--2TIkb"};